import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { addToStartOfChain } from "@insite/client-framework/HandlerCreator";
import { chain } from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { dispatchProductDetailEvent } from "@store/Services/AnalyticsService";
import { getCategory } from "@store/Store/Data/Categories/CategoriesSelectors";

addToStartOfChain(chain, props => {
    // `includeAttributes: ["includeOnProduct"]` needs to be sent to the "getProductByPath" service within the "LoadProductIfNeeded" handler chain.
    (props.parameter as any) = { includeAttributes: ["includeOnProduct"], ...props.parameter };
});

addToEndOfChain(chain, async props => {
    if (props.product) {
        await waitFor(() => !!props.pricingLoaded);

        const category = getCategory(props.getState());
        if (props.product && props.productInfosById) {
            const productContext: ProductContextModel = {
                product: props.product,
                productInfo: {
                    ...props.productInfosById[props.product.id],
                    productDetailPath: props.product.canonicalUrl,
                } as ProductInfo,
            };
            dispatchProductDetailEvent(productContext, category?.shortDescription || "");
        }
    }
});
